import { type ApiProblem, call } from '@rental/contracts/client'
import { api } from '../api'
import { sendPhoto } from '../photos/send'

/**
 * Q-157: a model photo taken in the app: a link for one file, then its bytes
 * from this device. The server stores it without its metadata (strip.ts);
 * until a model names it, it shows nowhere.
 */
export async function uploadModelPhoto(
  photo: Blob,
): Promise<{ ok: true; mediaId: string } | { ok: false; problem: ApiProblem }> {
  const link = await call(
    api.POST('/v1/staff/models/photos', {
      body: { contentType: 'image/jpeg', sizeBytes: photo.size },
    }),
  )
  if (!link.ok) return { ok: false, problem: link.problem }
  const failed = await sendPhoto(link.data.upload, photo)
  return failed ? { ok: false, problem: failed } : { ok: true, mediaId: link.data.mediaId }
}
